import { CheckoutState } from '../../state';

export const getPaypalScriptStatus = (state: CheckoutState) =>
    state.paypal.scriptStatus;

export const isLoadingPaypal = (state: CheckoutState) =>
    state.paypal.isLoadingPaypal;
